import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import { BoardMemberManagementConfig } from "./Data/BoardMemberManagementConfig";
import SwalAlert from "../../services/swalService/SwalService";
import { AddEditBordMember } from "./Data/AddEditBordMember.data";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import FormCreator from "../../components/Forms/FormCreator";
import MolGrid from "../../components/Grid/MolGrid";
import { useAddEditBoardMemberMutation,  useGetAllBoardMemberListMutation,useLazyDeleteBoardMemberByIdQuery,} from "../../app/services/boardMemberManagement/boardMemberManagementApi";
import { setAllDropDownFieldForBordMember } from "./utils/dropdownUtils";

const BoardMemberManagement = () => {
  const molGridRef = useRef();
  const bordMemberRef = useRef();
  const { error, success,confirm } = SwalAlert();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [formData, setFormData] = useState(AddEditBordMember);
  const [dataSource, setDataSource] = useState([]);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    endPage: 100,
    FilterByMembershipType: null,
    FilterByName: null,
  });

  const [signUpDropDownsForCorporateMembers,{data: signUpDropDownsData,isLoading: signUpDropDownsLoading,isFetching: signUpDropDownsFetching,},] = useLazyGetSignUpDropDownsForCorporateMembersQuery();
  const [getAllBoardMemberList,{isSuccess: getAllBoardMemberListIsSuccess,isLoading: getAllBoardMemberListIsLoading,data: getAllBoardMemberListData,},] = useGetAllBoardMemberListMutation();
  const [addEditBoardMember,{isSuccess: AddEditBoardMemberIsSuccess,isLoading: AddEditBoardMemberIsLoading,data: AddEditBoardMemberData,},] = useAddEditBoardMemberMutation();
  const [deleteBordMember,{data: deleteBordMemberData,isLoading: deleteBordMemberLoading,isFetching: deleteBordMemberFetching,},] = useLazyDeleteBoardMemberByIdQuery();

  const handleClear = () => {
    const updatedForm = { ...AddEditBordMember };
    setFormData(updatedForm);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
    setIsUpdate(false);
    handleClear();
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = {
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    };
    setPaginationRequest(updatedPaginationRequest);
    getAllBoardMemberList(updatedPaginationRequest);
  };

  const handleSubmit = () => {
    const formDetails = bordMemberRef?.current.getFormData();
    if (!formDetails) {
      error("Please fill in all mandatory fields to continue.", "");
      return;
    }

    let req = {
      AdminID: !isUpdate ? null : formDetails.adminId,
      BoardMemberName: formDetails.name,
      EmailAddress: formDetails.email,
      TypeOfMemberId: formDetails.typeofMember.value
        ? formDetails.typeofMember.value
        : formDetails.typeofMember,
    };
    addEditBoardMember(req);
  };

  const handleViewMember = (member) => {
    let form = { ...formData };
    setIsUpdate(true);
    let updateState = {
      name: member?.name,
      email: member?.email,
      typeofMember: member?.typeOfMemberID,
      adminId: member?.adminId,
    };
    setFormData((prev) => ({
      ...prev,
      ...form,
      initialState: { ...prev.initialState, ...updateState },
    }));
    setIsOpenModal(true);
  };

  const handleDeleteMember = (member) => {
    confirm('Delete?', 'Are you sure you want to delete?', 'Delete', 'Cancel').then((confirmed) => {
      if (confirmed) {
         deleteBordMember(member?.adminId);
      }
    });
  };

  const actionHandler = {
    VIEW: handleViewMember,
    DELETE: handleDeleteMember,
  };

  useEffect(() => {
    signUpDropDownsForCorporateMembers();
    getAllBoardMemberList(paginationRequest);
  }, []);

  useEffect(() => {
    if (!getAllBoardMemberListIsLoading && getAllBoardMemberListData) {
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: getAllBoardMemberListData.totalCount,
      }));
      setDataSource(getAllBoardMemberListData?.itemList);
    }
  }, [
    getAllBoardMemberListIsLoading,
    getAllBoardMemberListIsSuccess,
    getAllBoardMemberListData,
  ]);

  useEffect(() => {
    if (!signUpDropDownsLoading && signUpDropDownsData) {
      setAllDropDownFieldForBordMember(signUpDropDownsData);
    }
  }, [signUpDropDownsLoading, signUpDropDownsData]);

  useEffect(() => {
    if (!deleteBordMemberLoading && deleteBordMemberData) {
      success("Member deleted successfully");
      getAllBoardMemberList(paginationRequest);
    }
  }, [deleteBordMemberLoading, deleteBordMemberData]);

  useEffect(() => {
    if (!AddEditBoardMemberIsLoading && AddEditBoardMemberData) {
      success(`${AddEditBoardMemberData?.errorMessage=== "Update" ? "Member updated successfully" : "Member added successfully"}`);
      handleCloseModal();
      getAllBoardMemberList(paginationRequest);
    }
  }, [AddEditBoardMemberIsLoading, AddEditBoardMemberData]);

  return (
    <>
      {signUpDropDownsData ? (
        <div className="board-member-management">
          <div className=" btn-right-side ">
            <Buttons
              buttonText="Add New Board Member"
              buttonTypeClassName="success-btn"
              onClick={() => (setIsOpenModal(true), setIsUpdate(false))}
            />
          </div>
          {/* Grid Section Only */}
          <div className="member-list">
            <MolGrid
              ref={molGridRef}
              configuration={BoardMemberManagementConfig}
              dataSource={dataSource}
              allowPagination={true}
              pagination={paginationRequest}
              onPageChange={handlePageChange}
              onActionChange={actionHandler}
            />
          </div>
        </div>
      ) : (
        <DataLoader />
      )}
      {isOpenModal && (
        <CenterModel
          show={isOpenModal}
          handleClose={handleCloseModal}
          modelTitle={`${isUpdate ? "Update Member" : "Add Member"}`}
        >
          {/* <div className="board-member-management-model-title">
           {isUpdate ? "Update Member" : "Add Member"}
          </div> */}
          <div className="row">
            <FormCreator ref={bordMemberRef} {...formData} />
          </div>
          <Buttons
            buttonText={`${isUpdate ? "Update Member" : "Add New Board Member"}`}
            buttonTypeClassName="success-btn d-block m-auto mt-3"
            onClick={() => handleSubmit()}
            isLoading={AddEditBoardMemberIsLoading}
          />
        </CenterModel>
      )}
    </>
  );
};

export default BoardMemberManagement;
